const configLog = {
    log: {
        listLayout: 'LogListLayout',
        filterLayout: 'LogFilterLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getLog',
        listApiParamSet: {
            ip: 1,
            sp:10,
        }
    },
    logDaily: {
        listLayout: 'LogListDailyLayout',
        filterLayout: 'LogFilterDailyLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getLogDaily',
        listApiParamSet: {
            ip: 1,
            sp:10
        }
    },
}

export default {
    methods: {
        returnLogConfig(type) {
            return configLog[type];
        }
    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        server: {
            type:'match',
            classname : 'filterStatus',
        }
    }
}